import React, { useEffect } from 'react';
import classNames from 'classnames';
import { faCreditCard, faMessageLines, faPlateUtensils } from '@fortawesome/pro-light-svg-icons';
import { faTurtle } from '@fortawesome/pro-duotone-svg-icons';

import { hubLayout } from '../../../../helpers/hubLayout';
import { MODE_LOCAL } from '../../../../const/orders';
import { useHubLayout } from '../../../../hooks/useHubLayout';
import { useTableHashData } from '../../../../hooks/useTableHashData';
import ActionButton from '../../../../components/[tableHash]/selectAction/ActionButton';
import Copyright from '../../../../components/[tableHash]/newLayout/Copyright';
import HubBanner from '../../../../components/[tableHash]/HubBanner';
import l from '../../../../helpers/lang';
import ErrorPage from '../../../../components/error/ErrorPage';
import getQrHubProps from '../../../../helpers/hubProps';

function Page() {
  const { setLayoutFooter, resetLayoutHeader } = useHubLayout();
  const {
    tableHash,
    settings: {
      menuLink,
      isFeedbackConnected,
      isPaymentConnected,
      showPaymentBanner,
      country,
      hubBanner,
    },
    errorMessage,
  } = useTableHashData();

  useEffect(() => {
    resetLayoutHeader();
    setLayoutFooter(Copyright);
  }, []);

  const getPaymentLink = () => {
    if ((!isPaymentConnected && !showPaymentBanner) || country !== 'UA') {
      return null;
    }
    return `/hub/${tableHash}/select`;
  };

  const paymentLink = getPaymentLink();

  if (errorMessage) {
    const title = l('qr.errorPage/noConnection.errorTitle');
    const text = l('qr.errorPage/noConnection.errorText');

    return (
      <ErrorPage icon={faTurtle} title={title} text={text} />
    );
  }

  return (
    <div
      className={classNames('d-flex flex-column align-items-center h-100', { 'justify-content-center': !hubBanner })}
      data-testid="qr-hub-main-buttons-block"
    >
      {hubBanner && (
        <HubBanner src={hubBanner} />
      )}

      <div className="container p-3 d-grid gap-3 w-100">
        {menuLink && (
          <ActionButton
            href={`${menuLink}?mode=${MODE_LOCAL}`}
            label={l('qr.tableHash/selectAction.menuButton')}
            faIcon={faPlateUtensils}
            target="_blank"
            onClick={() => console.log('analytics', 'open_menu')}
            data-testid="menu-button"
          />
        )}
        {paymentLink && (
          <ActionButton
            href={paymentLink}
            label={l('qr.tableHash/selectAction.payButton')}
            faIcon={faCreditCard}
            data-testid="payment-button"
          />
        )}
        {isFeedbackConnected && (
          <ActionButton
            href={`/hub/${tableHash}/review`}
            label={l('qr.tableHash/selectAction.reviewButton')}
            faIcon={faMessageLines}
            data-testid="feedback-button"
            onClick={() => console.log('analytics', 'open_reviews')}
          />
        )}
      </div>
    </div>
  );
}

Page.getLayout = hubLayout;
Page.getInitialProps = getQrHubProps;

export default Page;
